<template>
  <div class="vip-page-guide-info-component"
       :style="itemStyle"
       id="vip-page-guide-info"
       @click="handleVipDetail"
  >
    <div class="vip-page-guide-info-tip">
      <ym-img class="vip-page-guide-info-icon"
              :src="icon"
              alt="vip图标"
      />
      <div class="vip-page-guide-info-desc"
            :style="tipStyle"
      >
        {{ tip.copywriting.desc }}
      </div>
      <div v-if="countDown.endTime > 0"
           class="vip-page-guide-info-count-down"
      >
        {{ countDown.leftText }}
        <ym-count-down :start="countDown.currentTime"
                       :end="countDown.endTime"
                       left-pad-str=""
        />
        {{ countDown.rightText }}
      </div>
    </div>
    <div class="vip-page-guide-info-btn"
         :style="buttonStyle"
    >
      {{ button.text }}
    </div>
  </div>
</template>

<script>
  import { locationHref } from '@/utils';
  import CountDown from '@/components/CountDown';

  export default {
    name: 'ProductDetailVipInformBar',
    components: {
      'ym-count-down': CountDown,
    },
    props: {
      button: {
        type: Object,
        required: true,
      },
      tip: {
        type: Object,
        required: true,
      },
      id: {
        type: Number,
        default: 1,
      },
      url: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
        required: true,
      },
      background: {
        type: Object,
        required: true,
      },
    },
    computed: {
      itemStyle() {
        const result = {};
        result.background = `linear-gradient(
          315deg, ${this.background.left} 0%, ${this.background.right} 100%)`;
        return result;
      },
      buttonStyle() {
        const result = {};
        result.background = `linear-gradient(
          315deg, ${this.button.background.left} 0%, ${this.button.background.right} 100%)`;
        result.color = this.button.color;
        return result;
      },
      tipStyle() {
        const result = {};
        result.color = this.tip.color;
        return result;
      },
      countDown() {
        const { tip: { copywriting } } = this;
        const { countDown } = copywriting || {};
        return countDown || { end: 0 };
      },
    },
    methods: {
      handleVipDetail() {
        locationHref(this.url);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .vip-page-guide-info {
    &-component {
      padding: 8px @size-base;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-tip {
      display: flex;
      align-items: center;
      font-size: @font-size-small;
      line-height: 1.2;
    }

    &-icon {
      width: 56px;
      margin-right: @size-extra-small;
    }

    @btn-height: 50px;
    &-btn {
      box-sizing: border-box;
      height: @btn-height;
      padding: 0 24px;
      border-radius: @btn-height;
      color: @color-text-gold;
      font-size: @font-size-extra-small;
      line-height: @btn-height;
      text-align: center;
    }

    &-count-down {
      display: flex;
    }
  }
</style>
